import * as FullStory from '@fullstory/browser';

export const fsInit = (initializer) => {
  FullStory.init(initializer);
};

export const fsIdentifyUser = (userId, userInfo) => {
  FullStory.identify(userId, userInfo);
};

export const fsSendMessageError = (message) => {
  FullStory.event('Error', message);
};

export const fsUserFinishFlow = (company) => {
  FullStory.event('Usuario temino el flujo completo', {
    company,
  });
};

export const fsCroppedImage = (frontImage, reverseImage) => {
  FullStory.event('Imagenes recortadas', {
    frontImage,
    reverseImage,
  });
};

export const fsSendPermissionStatus = (status, place) => {
  FullStory.event('Estatus del permiso', {
    status,
    place,
  });
};

export const fsShutDownRecord = () => {
  FullStory.shutdown();
};

export const fsSendWindowLocalStorageExist = (status) => {
  FullStory.event('Window localStorage', {
    status,
  });
};

export const fsLogger = (message) => {
  FullStory.event('Logs', {
    message,
  });
};

export const fsRejectSaveFieldsChangeStatus = (response) => {
  FullStory.event('Rejected Flow savefields', response);
};
